var $form = document.querySelector('.js-shipping-label-form');
var printDeclarationButton = document.querySelector('.js-print-declaration');
var $submitButton = document.querySelector('.js-submit-button');
var $loadingIcon = document.querySelector('.js-loading');

var $formStep1 = document.querySelector('.js-form-step-1');
var $formStep2 = document.querySelector('.js-form-step-2');
var $formStep3 = document.querySelector('.js-form-step-3');

var $formStep1Fields = $formStep1.querySelectorAll('input');
var $formStep2Fields = $formStep2.querySelectorAll('input');

var $previewTo = document.querySelector('.js-preview-to');
var $previewFrom = document.querySelector('.js-preview-from');

var $btnStep1 = $formStep1.querySelector('.js-btn-step');
var $btnStep2 = $formStep2.querySelector('.js-btn-step');

var $btnRestart = document.querySelector('.js-btn-restart');
var $btnBack = document.querySelectorAll('.js-btn-prev');

var $barCodeImage = document.querySelector('#js-barcode-image');
var $barCodeInput = document.querySelector('.js-barcode-input');

var $heroTitle = document.querySelector('.js-hero-title');
var $heroSuccessMessage = document.querySelector('.js-hero-success-message');

var $toastSuccess = document.querySelector('.js-alert-toast');

let DataFrom = {};
let DataTo = {};

const FORM_ACTION = $form.action;

// Subscribe form
var $formSubscribe = document.querySelector('.js-form-subscribe');

function handleStart() {
    // Mask inputs
    $('.js-cep').mask('00000-000');

    // Check form steps
    const validate = new Bouncer('.js-shipping-label-form', {
        disableSubmit: true,
        messages: {
            missingValue: {
                text: validationErrors.required,
                number: validationErrors.required,
                email: validationErrors.required
            },
            patternMismatch: {
                email: validationErrors.email,
            },
        },
    });

    $submitButton.addEventListener('click', (e) => {
        generateDeclaration(e);

        setTimeout(() => {
            handleSubscribeForm();
        },2000);
    });

    $btnRestart.addEventListener('click', (e) => {
        e.preventDefault();
        handleStep($heroSuccessMessage, $heroTitle);
        handleRestart();
    })

    // Steps
    handleStep1(validate);
    handleStep2(validate);

    // Back when needed
    handleBackStep();
}

// Handle form action
// - Generate document when form is submitted
function generateDeclaration(event) {
    event.preventDefault();
    $form.submit();

    // Show toast success alert
    $toastSuccess.classList.add('opened');

    setTimeout(() => {
        $toastSuccess.classList.remove('opened')
    }, 3500);
};

// Restart form and check if has data to keep
function handleRestart() {
    var keepSenderData = document.querySelector('#keep_sender').checked;

    if(!keepSenderData) {
        $form.reset();
    } else {
        $formStep2Fields.forEach(el => {
            el.value = ''
        });
    }

    handleStep(3,1);
}

// Handle form subscribe to sent data for Hubspot
function handleSubmitFormSubscribe() {
    var getName = $form.from_name.value;
    var getEmail = $form.from_email.value;

    $formSubscribe.firstname.value = getName;
    $formSubscribe.email.value = getEmail;

    toolsSubscribe();

    $formSubscribe.querySelector('.js-form-subscribe-btn').click();
    amplitude_log_event('tools_subscribed', {
        'tool_name': landing
    });
    hubspotCustomEvents('tools_' + landing + '_subscribed');
}

// Handle steps
function handleStep(stepFrom, stepTo) {
    if(typeof stepFrom == 'object') {
        var $getFrom = stepFrom;
        var $goTo = stepTo;
    } else {
        var $getFrom = document.querySelector('.js-form-step-' + stepFrom );
        var $goTo = document.querySelector('.js-form-step-' + stepTo);
    }

    $getFrom.classList.add('slide-up-out');
    $goTo.classList.add('slide-up');

    $getFrom.ariaHidden = true;
    $goTo.ariaHidden = false;

    setTimeout(() => {
        $getFrom.classList.add('hide');
        $goTo.classList.remove('hide');
        $goTo.classList.remove('slide-up-out');
    },100)
}

// Handle back step
function handleBackStep() {
    $btnBack.forEach(el => {
        el.addEventListener('click', () => {
            var currentStep = el.dataset.current;
            var nextStep = el.dataset.next;

            handleStep(currentStep, nextStep);
        })
    })
}

// Cep Validation
async function getCepData(cepField) {
    var cepValue = cepField.value;

    const findCep = await fetch('https://viacep.com.br/ws/'+cepValue+'/json/');
    const response = await findCep.json();
    return response;
}

// Generate barcode and add to image tag and related input
function generateBarcode(value) {
    var formattedValue = value.replace('-', '');

    JsBarcode($barCodeImage, formattedValue, {
        height: 70
    });

    $barCodeInput.value = $barCodeImage.src;
}

// Handle step actions
function handleStep1(validate) {
    var $cepStep1 = $formStep1.querySelector('.js-cep');

    $cepStep1.addEventListener('blur', async () => {
        if($cepStep1.value !== "") {
            const $address = $formStep1.querySelector('.js-address');
            const $city = $formStep1.querySelector('.js-city');

            $address.classList.add('background-color-primary-blue-10');
            $city.classList.add('background-color-primary-blue-10');
            $address.value = cepLoading;
            $city.value = cepLoading;

            const cepData = await getCepData($cepStep1);

            setTimeout(() => {
                if(!cepData.erro) {
                    $address.value = cepData.logradouro + ' - ' + cepData.bairro;
                    $city.value = cepData.localidade + ' - ' + cepData.uf;
                } else {
                    $address.value = '';
                    $city.value = '';
                }

                $address.classList.remove('background-color-primary-blue-10');
                $city.classList.remove('background-color-primary-blue-10');

            }, 700);
        }
    });

    $btnStep1.addEventListener('click', function(el) {
        const nextStep = el.target.dataset.next;
        const currentStep = parseInt(nextStep) - 1;
        const isValidStep1 = validate.validateAll($formStep1);

        if(isValidStep1.length == 0) {
            fillDataObjectFromNode($formStep1Fields, DataFrom);
            handleStep(currentStep, nextStep);
        }
    });
}

function handleStep2(validate) {
    var $cepStep2 = $formStep2.querySelector('.js-cep');

    $cepStep2.addEventListener('blur', async () => {
        if($cepStep2.value !== "") {
            const $address = $formStep2.querySelector('.js-address');
            const $city = $formStep2.querySelector('.js-city');

            $address.classList.add('background-color-primary-blue-10');
            $city.classList.add('background-color-primary-blue-10');

            $address.value = cepLoading;
            $city.value = cepLoading;

            const cepData = await getCepData($cepStep2);

            setTimeout(() => {
                if(!cepData.erro) {
                    $address.value = cepData.logradouro + ' - ' + cepData.bairro;
                    $city.value = cepData.localidade + ' - ' + cepData.uf;
                } else {
                    $address.value = '';
                    $city.value = '';
                }

                $address.classList.remove('background-color-primary-blue-10');
                $city.classList.remove('background-color-primary-blue-10');

            }, 700);
        }
    });

    $btnStep2.addEventListener('click', (el) => {
        const nextStep = el.target.dataset.next;
        const currentStep = parseInt(nextStep) - 1;
        const isValidStep2 = validate.validateAll($formStep2);

        if(isValidStep2.length == 0) {
            generateBarcode($cepStep2.value);
            fillDataObjectFromNode($formStep2Fields, DataTo);
            handleResultsPreview();
            handleStep(currentStep, nextStep);
            handleStep($heroTitle, $heroSuccessMessage);
        }
    });
}

// Preview results data
function handleResultsPreview() {
    // Preview data from Sender
    handleReplaceDataField($previewFrom, '$FROM_NAME', DataFrom.from_name);
    handleReplaceDataField($previewFrom, '$FROM_ADDRESS', DataFrom.from_address + ' - ' + DataFrom.from_number);
    handleReplaceDataField($previewFrom, '$FROM_CITY', DataFrom.from_city);
    handleReplaceDataField($previewFrom, '$FROM_CEP', DataFrom.from_cep);

    // Preview data from Receptor
    handleReplaceDataField($previewTo, '$TO_NAME', DataTo.to_name);
    handleReplaceDataField($previewTo, '$TO_ADDRESS', DataTo.to_address + ' - ' + DataTo.to_number);
    handleReplaceDataField($previewTo, '$TO_CITY', DataTo.to_city);
    handleReplaceDataField($previewTo, '$TO_CEP', DataTo.to_cep);
}

// Get all input filled to show an preview
function fillDataObjectFromNode($nodeElement, data) {
    $nodeElement.forEach(field => {
        data[field.id] = field.value
    });
}

// Replace data from specific node element
function handleReplaceDataField($nodeElement, input, output) {
    $nodeElement.querySelector('[data-field="'+input+'"]').innerHTML = output;
}

// Handle subscription form to store user data on Hubspot
async function handleSubscribeForm() {
    if( !$.cookie('tool_' + landing + '_subscribe_modal_gate') ) {
        toolsSubscribe();

        $('#modal-subscribe').modal('show');
        amplitude_log_event('tools_' + landing + '_modal', {
            'state': 'opened'
        });

        document.addEventListener('onToolsSubscribe', function (params) {
            $('#modal-subscribe').modal('hide');
            amplitude_log_event('tools_' + landing + '_modal', {
                'state': 'closed'
            });

            $.cookie('tool_' + landing + '_subscribe_modal_gate', true, { expires: 30, path: '/' });

            amplitude_log_event('tools_subscribed', {
                'tool_name': landing
            });
        })

    }
}

function checkIfReady() {
    if (typeof Bouncer != 'undefined' && typeof toolsSubscribe != 'undefined' && typeof jQuery !== 'undefined' && typeof $.fn.mask != 'undefined' && typeof JsBarcode != 'undefined') {
        handleStart();
    } else {
        setTimeout(checkIfReady, 1000);
    }
}

checkIfReady();